/**
 * Traduce el código de error/reason que devuelve la API de horarios (ver
 * api-programacion-horarios.md) a una explicación entendible. Compartido entre "Programación de
 * horarios" (individual) y "Programación masiva de horarios", que reciben el mismo catálogo de
 * códigos en sus respectivos 409/Reason.
 *
 * Ojo con `PAYROLL_DAYS_APPROVED`: NINGÚN permiso de estas pantallas lo resuelve — es un bloqueo
 * administrativo de Prenómina (permiso `payroll.reset`, botón "Re-evaluar" en Empleador > Entradas
 * y salidas), no de permisos de reprogramación. Confirmado con un caso real: un usuario con
 * `schedule.edit-past` activo seguía sin poder reprogramar un día porque su prenómina ya estaba
 * revisada — el mensaje anterior le pedía un permiso que ya tenía, lo cual era incorrecto.
 */
export function describeScheduleErrorHint(code: string | undefined): string {
  if (code === 'PAYROLL_DAYS_APPROVED') {
    return ' Este día ya tiene la prenómina aprobada/revisada: ningún permiso de esta pantalla lo destraba. Hay que devolverlo a "Sin revisar" desde Prenómina antes de poder reprogramarlo.';
  }
  if (code === 'PAST_DAYS_NOT_ALLOWED') {
    return ' Hace falta el permiso "Programar días ya transcurridos" (schedule.edit-past), y que la prenómina de ese día esté "Sin revisar".';
  }
  if (code === 'ROTATION_INACTIVE') {
    return ' La rotación está inactiva: actívala en "Configuración de horario de trabajo" para poder asignarla.';
  }
  return '';
}
